<template>
    <form-input :class="wrapClasses" :error="error">
        <label v-if="label" :for="id">
            {{ label }} <template v-if="isRequired"><span class="asterisk">*</span></template>
        </label>
        <tree-select
            @input="onChange"
            @submit="onSubmit"
            :placeholder="placeholder"
            :name="name"
            :id="id"
            :options="options"
            :value="value"
            :max-selected-names="maxSelectedNames"
            :is-multiple="isMultiple"
            :parent-auto-check="parentAutoCheck"
            :strings="translations"
            :only-end-nodes="onlyEndNodes"
            :use-search="useSearch"
            :use-select-all="useSelectAll"
            :html-title="htmlTitle"
            :is-disabled="isDisabled"
            :max-checked-options="maxCheckedOptions"
        ></tree-select>
        <help-block :text="error"/>
    </form-input>
</template>

<script>
    import TreeSelect from '../TreeSelect/Select';

    export default {
        components: {
            'tree-select': TreeSelect
        },
        props: {
            label: String,
            error: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String,
                default: ''
            },
            name: String,
            id: String,
            options: {
                type: Array,
                default() {
                    return [];
                }
            },
            value: {
                type: [Number, String, Array],
                default() {
                    return [];
                }
            },
            maxSelectedNames: {
                type: Number,
                default: 3
            },
            isMultiple: {
                type: Boolean,
                default: true
            },
            isRequired: {
                type: Boolean,
                default: false
            },
            isDisabled: {
                type: Boolean,
                default: false
            },
            parentAutoCheck: {
                type: Boolean,
                default: true
            },
            classes: {
                type: String,
                default: ''
            },
            htmlTitle: {
                type: Boolean,
                default: false
            },
            onlyEndNodes: {
                type: Boolean,
                default: false
            },
            useSearch: {
                type: Boolean,
                default: true
            },
            useSelectAll: {
                type: Boolean,
                default: true
            },
            maxCheckedOptions: {
                type: [Number, Boolean],
                default: false
            }
        },
        data() {
            return {
                translations: {
                    searchPlaceholder: 'Search...',
                    emptyTitle: 'No options!',
                    selectAllOptions: 'Select All',
                    allSelected: 'All Selected',
                    selectedCount: 'Selected {selected} of {all} items',
                    buttonTitle: 'Ok'
                }
            };
        },
        computed: {
            wrapClasses() {
                return 'form-select ' + this.classes + (this.error ? ' has-error' : '');
            }
        },
        methods: {
            onChange(value) {
                const valueToPass = this.isMultiple ? value : value[0];
                this.$emit('input', valueToPass);
            },
            onSubmit(value) {
                const valueToPass = this.isMultiple ? value : value[0];
                this.$emit('submit', valueToPass);
            }
        }
    }
</script>
